export default "__VITE_ASSET__BiOKfk9G__"